import { notifications } from '@mantine/notifications';
import { IconCheck, IconExclamationCircle } from '@tabler/icons-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Endpoints } from '../../apis';
import { getErrorMessage } from '@xver/utils/error';

export function useDeleteSecurityGroupMutate() {
    const { t } = useTranslation('notifications');
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (id: string) => Endpoints.v1.Firewalls.SecurityGroups.deleteSecurityGroup(id),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['api.v1.firewalls.security-groups.infinite'],
            });
            notifications.show({
                title: t('securityGroup.deletedTitle'),
                message: t('securityGroup.deletedMessage'),
                icon: <IconCheck size={32} color={'#00ff00'} />,
            });
        },
        onError: (error: any) => {
            notifications.show({
                title: t('securityGroup.deleteFailedTitle'),
                message: getErrorMessage(error),
                icon: <IconExclamationCircle size={32} color={'#eb5757'} />,
            });
        },
    });
}
